<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="commonApprovalFormStyles approvalProcess" :class="{'isNews': isNews}">
            <van-loading
                class="pageLogin"
                v-if="isloading"
                type="spinner"
                color="#1989fa"
            ></van-loading>
            <van-nav-bar
                title="审批办理"
                :left-text="backPathName=='contractApproval'?'审批列表':''"
                left-arrow
                v-if="isNews != true"
                @click-left="onClickLeft"
            >
                <template #right v-if="businessRemindList.length > 0">
                    <div class="tips">
                        <van-badge :content="businessRemindList.length">
                            <i class="iconfont iconxiangqingon tipsBtn" @click="openAllTips"></i>
                        </van-badge>
                        <div v-if="showTipsPopover" class="tipsPopover">
                            <i class="iconfont icontishi"></i>
                            <span></span>
                            <button class="iconfont iconguanbi" @click="promptReadClick"></button>
                            <p>{{ showUnreadData.RemindContent }}</p>
                        </div>
                    </div>
                </template>
            </van-nav-bar>
            <section :class="{'readOnly': isReadOnly || phaseType == 0 || transferState > 1}">
                <van-tabs
                    v-model="active"
                    animated
                    line-width="80"
                >
                    <van-tab title="基本信息" class="BasicContractInfo essentialInfo">
                        <dl class="infoBg">
                            <dd class="infoList">
                                <template v-for="(item, index) in essentialInfoField">
                                    <template v-if="item.IsShow">
                                        <template v-if="essentialInfoData">
                                            <h4 :key="`infoList_${index}`" class="contractNumber" v-if="item.Field == 'contract_number'">
                                                {{ item.FieldName }}：{{ essentialInfoData[item.Field] }}
                                            </h4>
                                            <van-cell
                                                v-else-if="item.Methed != null || item.Field == 'engineering_location'"
                                                :key="`infoList_${index}`"
                                                :value="essentialInfoData[item.Field]"
                                                :title="item.FieldName"
                                            ></van-cell>
                                            <van-cell
                                                v-else
                                                :key="`infoList_${index}`"
                                                :value="essentialInfoData[item.Field]"
                                                :title="item.FieldName"
                                            ></van-cell>
                                        </template>
                                        <template v-else>
                                            <h4 :key="`infoList_${index}`" class="contractNumber" v-if="item.Field == 'contract_number'">
                                                {{ item.FieldName }}：
                                            </h4>
                                            <van-cell
                                                v-if="item.Methed != null || item.Field == 'engineering_location'"
                                                :key="`infoList_${index}`"
                                                value=""
                                                :title="item.FieldName"
                                                is-link
                                            ></van-cell>
                                            <van-cell
                                                v-else
                                                :key="`infoList_${index}`"
                                                value=""
                                                :title="item.FieldName"
                                            ></van-cell>
                                        </template>
                                    </template>
                                </template>
                            </dd>
                        </dl>
                    </van-tab>
                    <van-tab title="审批表单" class="approvalForm">
                        <template v-for="(item, index) in formData">
                            <van-cell
                                :key="index"
                                :title="item.FormName"
                                class="formList iconfont iconwenjian"
                                @click="openForm(item)"
                                is-link
                            >
                            </van-cell>
                        </template>
                    </van-tab>
                    <van-tab title="附件资料">
                        <div class="appendix_list">
                            <button v-if="thisFileID != '0'" class="attachmentReturnBtn iconfont iconfanhui2" @click="attachmentReturn">
                                返回上一级
                            </button>
                            <ul>
                                <template v-for="(item, index) in attachmentData">
                                    <li
                                        :key="`attachment_${index}`"
                                        :class="{'folder':item.FileType == '1', 'file': item.FileType == '2'}"
                                        @click="attachmentPreview(item)"
                                    >
                                        <span class="iconfont fileIcon" :class="addClassName(item)"></span>
                                        <div class="fileInfo">
                                            <p class="fileName">
                                                {{ item.FileName }}
                                            </p>
                                            <p v-if="item.FileType !== '1'">
                                                <em>{{ item.CreateDate || '暂无日期' }}</em>
                                                <em v-if="item.FileType !== '1'">
                                                    <template v-if="item.FileSize > 1048576">
                                                        {{ (item.FileSize/1048576).toFixed(2) }}M
                                                    </template>
                                                    <template v-else-if="item.FileSize < 1048576 && item.FileSize > 1024">
                                                        {{ (item.FileSize/1024).toFixed(2) }}k
                                                    </template>
                                                    <template v-else>
                                                        {{ item.FileSize }}b
                                                    </template>
                                                </em>
                                            </p>
                                        </div>
                                        <i class="iconfont iconfanhui1"></i>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </van-tab>
                    <van-tab title="审批动态">
                        <div class="flowChartList">
                            <template v-for="(item,index) in dynamicData">
                                <div class="procedureList" :class="{'countersignatureNode': item.node_type ==3}" :key="index">
                                    <h3 class="countersignatureTitle" v-if="item.node_type ==3">
                                        <i class="countersign"></i>
                                        会签审核
                                    </h3>
                                    <template v-for="(k, i) in item.data">
                                        <div class="listBox" :key="i">
                                            <h4>
                                                <span>{{ k.Content }}</span>
                                            </h4>
                                            <div class="userInfo">
                                                <span class="headPortrait">
                                                    <img src="./images/head_portrait2.png" alt="头像">
                                                    <i class="icon"></i>
                                                </span>
                                                <div>
                                                    <div class="stateBox">
                                                        <span class="name">{{ k.ApproverName }}</span>
                                                        <span class="state">({{ k.ParticipantAction }})</span>
                                                    </div>
                                                    <span class="time">{{ k.EndTime }}</span>
                                                </div>
                                            </div>
                                            <ul>
                                                <template v-for="(z, j) in k.CommentList">
                                                    <li :key="j">
                                                        {{ z.Content }}
                                                    </li>
                                                </template>
                                            </ul>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </van-tab>
                </van-tabs>
                <!-- <button class="communicate" @click="communicate">
                    <p class="iconfont icongoutong"></p>
                    沟通
                </button> -->
                <button v-if="isReadOnly == false && isFillOpinion" class="opinion" @click="opinion">
                    <p class="iconfont iconyijian"></p>
                    <span>意见</span>
                </button>
                <!-- 所有提示展示层 -->
                <van-popup v-model="showAllTips" class="flowPathTips">
                    <h4>审批消息</h4>
                    <ul>
                        <template v-for="(item, index) in businessRemindList">
                            <li :key="`tips_${index}`">
                                <div>
                                    <i class="state" v-if="item.RecordStatus == 0"></i>
                                    <i class="state read" v-if="item.RecordStatus == 1"></i>
                                    <p>{{ item.RemindContent }}</p>
                                </div>
                                <p class="iconfont iconshijian">
                                    {{ item.CreateDate }}
                                </p>
                            </li>
                        </template>
                        <li>
                            <div>
                                <i class="state"></i>
                                <p>当前合同有新收款XX万元，是否继续审批本超限发货申请？</p>
                            </div>
                            <p class="iconfont iconshijian">
                                2022-02-09
                            </p>
                        </li>
                        <li>
                            <div>
                                <i class="state read"></i>
                                <p>当前合同有新收款XX万元，是否继续审批本超限发货申请？</p>
                            </div>
                            <p class="iconfont iconshijian">
                                2022-02-09
                            </p>
                        </li>
                        <li>
                            <div>
                                <i class="state"></i>
                                <p>当前合同有新收款XX万元，是否继续审批本超限发货申请？</p>
                            </div>
                            <p class="iconfont iconshijian">
                                2022-02-09
                            </p>
                        </li>
                    </ul>
                    <van-button plain type="info" @click="allpromptReadClick">
                        我知道了
                    </van-button>
                </van-popup>
                <!-- 提交确认弹出层 -->
                <van-dialog
                    v-model="confirmedByShow"
                    title="提交确认"
                    show-cancel-button
                    @cancel="cancelSubmission"
                    @confirm="confirmSubmission"
                    class="submitPopUp"
                >
                    <div class="submitPopUpContent">
                        <div class="info linkInfo">
                            <div class="infoList approvalPhase">
                                <i class="icon iconfont iconshenpi"></i>
                                <h4>
                                    <p>下一环节：</p>
                                    <span>{{ submitObj.link }}</span>
                                </h4>
                            </div>
                            <div class="infoList approver">
                                <i class="icon iconfont icon04gerenfill"></i>
                                <h4>
                                    <p>审批人：</p>
                                    <span>{{ submitObj.obj }}</span>
                                </h4>
                            </div>
                        </div>
                    </div>
                    <p class="tips">
                        是否确认提交？
                    </p>
                </van-dialog>
            </section>
            <footer class="commonFormBtns" v-if="isReadOnly == false && phaseType != 0 && transferState < 2">
                <button v-if="phaseType != 5 && submitBtn.length>0" @click="submit">
                    {{ submitBtn[0].name }}
                </button>
                <button v-if="phaseType != 5 && freeSubmission.length>0" @click="customSubmit">
                    {{ freeSubmission[0].name }}
                </button>
                <button v-if="cross_approvalBtn.length > 0" @click="crossApproval">
                    {{ cross_approvalBtn[0].name }}
                </button>
                <button v-if="phaseType == 1 && cross_backprocessBtn.length > 0" @click="crossBackProcess">
                    {{ cross_backprocessBtn[0].name }}
                </button>
                <button v-if="phaseType != 1 && returnBtn.length > 0" @click="sendBack">
                    {{ returnBtn[0].name }}
                </button>
                <button v-if="nopassBtn.length > 0" @click="nopass">
                    {{ nopassBtn[0].name }}
                </button>
                <button v-if="endBtn.length > 0" @click="end">
                    {{ endBtn[0].name }}
                </button>
                <button v-if="returnSubmitBtn.length > 0" @click="returnSubmit">
                    {{ returnSubmitBtn[0].name }}
                </button>
            </footer>
        </div>
    </v-touch>
</template>
<script>
import { ImagePreview } from 'vant';

export default {
    // 审批办理
    name: 'approval-process',
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/contractApproval') {
            this.$store.commit('noKeepAlive', 'approval-process');
        }
        next();
    },
    props: {},
    data() {
        return {
            // loading状态
            isloading: false,
            // 审批动态流程节点下标
            currentStep: 0,
            // 当前tab页下标
            active: 0,
            // 是否只读
            isReadOnly: false,
            // 审批数据
            approvalData: {},
            // 基本信息字段数据
            essentialInfoField: [],
            // 基本信息数据
            essentialInfoData: [],
            // 合同编号（沟通用）
            contractNo: '',
            // 流程数据
            processData: {},
            // 流程环节类型
            phaseType: 0,
            // 审批状态
            transferState: 0,
            // 表单数据
            formData: [],
            // 显示附件数据
            attachmentData: [],
            // 所有附件数据
            allAttachmentData: [],
            attachmentActive: [],
            thisFileID: '0',
            // 审批动态数据
            dynamicData: [],
            // 当前流程环节信息
            CurrentBusinessProcess: {},
            // 当前流程基本信息
            BusinessInstanceInfo: {},

            // 提交按钮
            submitBtn: [],
            // 自由提交
            freeSubmission: [],
            // 结束按钮
            endBtn: [],
            // 退回按钮
            returnBtn: [],
            // 跨级审批按钮
            cross_approvalBtn: [],
            // 跨级退回按钮
            cross_backprocessBtn: [],
            // 审核不通过
            nopassBtn: [],
            // 退回提交
            returnSubmitBtn: [],

            // 环节审批角色id
            approverRoleId: [],
            // 环节审批角色name
            approverRoleName: [],
            // 确认人员弹出层状态
            confirmedByShow: false,
            submitObj: {
                link: '',
                obj: '',
            },
            // 附件预览地址
            url: '',
            // 是否是消息跳转审批
            isNews: false,
            // 是否填写意见
            isOpinion: false,
            // 意见
            opinionRecord: {},
            // 是否是当前办理填写的意见
            isNewestOpinion: true,
            // 是否需要填写意见
            isFillOpinion: true,
            // 多租户消息跳转办理页面
            // 取当前消息租户token
            newsToken: '',
            // 消息打开办理页面
            isMessageHandling: false,

            // 提示数据集合
            businessRemindList: [],
            // 流程提示[有未读提示显示]
            showTipsPopover: null,
            // 显示未读[显示所有未读提示最后一条]
            showUnreadData: {},
            // 所有提示弹出层状态
            showAllTips: false,

            // 返回的页面 name
            backPathName: 'contractApproval',
        };
    },
    computed: {},
    watch: {
        businessRemindList(newVal) {
            if (newVal.length > 0) {
                // 显示未读[显示所有未读提示最后一条]
                const unreadData = newVal.filter(item => item.RecordStatus === 0);
                if (unreadData.length > 0) {
                    this.showUnreadData = unreadData[unreadData.length - 1];
                    this.showTipsPopover = true;
                } else {
                    this.showTipsPopover = false;
                }
            }
        },
    },
    async created() {
        await this.init();
    },
    activated() {
        if (this.$route.params.commentsCallback) {
            // 拉取审批意见
            this.getApprovalComments();
        }
        if (this.$route.params.isRefresh) {
            this.isReadOnly = true;
        }
    },
    mounted() { },
    destroyed() { },
    methods: {
        // 初始化页面
        async init() {
            // 读取父页面审批数据
            if (this.$route.params.data) {
                this.approvalData = this.$route.params.data;
                this.isNews = this.$route.params.isNews;
                // 判断是否需要填写意见， BusinessCode等于HTPS-LS2不需要填写意见
                if (this.approvalData.BusinessCode === 'HTPS-LS2') {
                    this.isFillOpinion = false;
                }
                // 是否已审批，已审批只读
                if (this.$route.params.isReadOnly) {
                    this.isReadOnly = this.$route.params.isReadOnly;
                } else {
                    this.isReadOnly = false;
                }
                // 有tenant_id，消息列表跳转办理页面，判断多租户
                if (this.approvalData.tenant_id) {
                    this.isMessageHandling = true;
                    const tenantID = this.$takeTokenParameters('TenantId');
                    if (this.approvalData.tenant_id !== tenantID) {
                        const res = await this.getTenantToken(this.approvalData.tenant_id);
                        this.newsToken = res.AccessToken;
                    } else {
                        this.newsToken = '';
                    }
                }

                // 获取基本信息字段数据
                this.getEssentialInfoField();
                // 获取流程数据
                this.getProcessData();
            }
            // 转发原生回调函数
            window.callback_GetTeamsListInfo = this.callback_GetTeamsListInfo;
        },
        // 返回上级页面
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: this.backPathName,
            });
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            if (this.isNews !== true) {
                this.$router.isBack = 1;
                this.$router.replace({
                    name: this.backPathName,
                });
                this.$router.go(-1);
            }
        },
        // 获取基本信息字段数据
        async getEssentialInfoField() {
            this.essentialInfoField = await this.getEssentialInfoFieldRequest();
            // 获取基本信息数据
            this.essentialInfoData = [];
            this.contractNo = '';
            this.getEssentialInfoData();
        },
        // 获取基本信息数据
        async getEssentialInfoData() {
            const res = await this.getEssentialInfoDataRequest();
            if (res) {
                this.essentialInfoData = res;
                this.contractNo = res.contract_number;
            }
            this.$forceUpdate();
        },
        // 根据环节获取流程实例信息
        async getProcessData() {
            const res = await this.getProcessDataRequest();
            // 流程数据
            this.processData = res;
            // 流程环节类型
            this.phaseType = res.CurrentBusinessProcess.PhaseType;
            // 审批状态
            this.transferState = res.CurrentBusinessProcess.TransferState;
            // 表单数据赋值
            this.formData = res.BusinessFormList;
            // 附件数据赋值
            this.allAttachmentData = res.FileGroupInstanceList;
            if (res.FileGroupInstanceList.length > 0) {
                // 附件数据处理
                this.processingAttachmentData(res.FileGroupInstanceList);
            }
            // 审批动态数据
            this.dynamicData = res.HistoryNewRecordList;
            // 当前流程基本信息
            this.BusinessInstanceInfo = res.BusinessInstanceInfo;
            // 当前流程环节信息
            this.CurrentBusinessProcess = res.CurrentBusinessProcess;
            // IsNotRequiredOpinion = true意见选填，= false 意见必填
            if (!this.CurrentBusinessProcess.IsNotRequiredOpinion) {
                // 拉取审批意见
                await this.getApprovalComments();
            } else {
                this.isOpinion = true;
            }

            // 流程提示集合
            this.businessRemindList = res.BusinessRemindList || [];

            // 按钮数据集合
            this.BusinessActionList = res.BusinessActionList;
            this.BusinessActionList.forEach(item => {
                if (item.ActionCode === 'submit') {
                    this.submitBtn.push({
                        code: 'submit',
                        name: item.CustomName || item.ActionName,
                    });
                } else if (item.ActionCode === 'customSubmit') {
                    this.freeSubmission.push({
                        code: 'customSubmit',
                        name: item.CustomName || item.ActionName,
                    });
                } else if (item.ActionCode === 'return') {
                    this.returnBtn.push({
                        code: 'return',
                        name: item.CustomName || item.ActionName,
                    });
                } else if (item.ActionCode === 'cross_approval') {
                    this.cross_approvalBtn.push({
                        code: 'cross_approval',
                        name: item.CustomName || item.ActionName,
                    });
                } else if (item.ActionCode === 'cross_backprocess') {
                    this.cross_backprocessBtn.push({
                        code: 'cross_backprocess',
                        name: item.CustomName || item.ActionName,
                    });
                } else if (item.ActionCode === 'end') {
                    this.endBtn.push({
                        code: 'end',
                        name: item.CustomName || item.ActionName,
                    });
                } else if (item.ActionCode === 'nopass') {
                    this.nopassBtn.push({
                        code: 'nopass',
                        name: item.CustomName || item.ActionName,
                    });
                } else if (item.ActionCode === 'returnsubmit') {
                    this.returnSubmitBtn.push({
                        code: 'returnsubmit',
                        name: item.CustomName || item.ActionName,
                    });
                }
            });
        },
        // 附件图标
        addClassName(item) {
            let className = '';
            if (item.FileType === '1') {
                className = 'iconfujian';
            } else if (item.FileType === '2') {
                if (/png/i.test(item.FileName)) {
                    className = 'icontupian';
                } else if (/jpg/i.test(item.FileName)) {
                    className = 'icontupian';
                } else if (/gif/i.test(item.FileName)) {
                    className = 'icontupian';
                } else if (/pdf/i.test(item.FileName)) {
                    className = 'iconpdf1';
                } else if (/docx/i.test(item.FileName)) {
                    className = 'iconbg-word';
                } else if (/xlsx/i.test(item.FileName)) {
                    className = 'iconxls';
                } else if (/ppt/i.test(item.FileName)) {
                    className = 'iconPPT';
                } else if (/txt/i.test(item.FileName)) {
                    className = 'icontxt';
                } else {
                    className = 'iconPPT';
                }
            }
            return className;
        },
        // 附件数据处理
        processingAttachmentData(data) {
            const folderData = data.filter(item => item.ParentID === '0' && item.FileName !== '现场照片');
            if (folderData.length > 0) {
                this.attachmentData = folderData;
            } else {
                this.attachmentData = data.filter(item => item.FileName !== '现场照片');
            }
        },
        // 提交
        async submit() {
            if (this.isFillOpinion) {
                if (!this.isOpinion) {
                    this.$toast('请先填写意见！');
                    return;
                }
            }

            if (!this.isNewestOpinion) {
                this.$dialog.confirm({
                    message: '填写的意见是上次办理时填写的，确认直接提交？',
                })
                    .then(() => {
                        // 确认提交
                        this.submitConfirm();
                    });
            } else {
                // 确认提交
                this.submitConfirm();
            }
        },
        // 确认提交
        async submitConfirm() {
            let childrenData;
            // 获取环节数据请求
            // eslint-disable-next-line max-len
            const linkData = await this.getLinkDataRequest(this.approvalData.BusinessInstanceId, this.CurrentBusinessProcess.CurrentBusinessProcessId);

            // 提交会签环节
            if (!linkData.SubmitPhaseModel && linkData.SubmitPhaseNodes) {
                childrenData = {
                    title: '会签提交',
                    type: 'countersign',
                    processData: this.processData,
                };
            } else if (// 判断环节提交模式和审批人类别，环节提交模式=1（默认环节），审批人类别=2（角色），打开选择人员弹出层
                linkData.PhaseSubmitMode === 1
                && linkData.SubmitPhaseModel?.ApproverType === 2
                && linkData.SubmitPhaseModel?.IsAllowEditApprover
            ) {
                childrenData = {
                    title: '普通提交',
                    type: 'role',
                    processData: this.processData,
                };

                // 判断环节提交模式和审批人类别，环节提交模式=2或者=3（指定环节、自由环节）
            } else if ([2, 3].indexOf(linkData.PhaseSubmitMode) > -1) {
                this.businessPhaseId = linkData.BusinessPhaseId;
                childrenData = {
                    title: '自由提交',
                    type: 'link',
                    processData: this.processData,
                };
            } else {
                this.submitObj.link = linkData.SubmitPhaseModel?.BusinessPhaseName;
                this.submitObj.obj = linkData.SubmitPhaseModel?.ApproverName;
                this.confirmedByShow = true;
            }

            if (childrenData) {
                let pathName = this.backPathName;
                if (this.isMessageHandling) {
                    pathName = 'approvalProcess';
                }
                this.$router.isBack = 2;
                this.$router.push({
                    name: 'submission',
                    params: {
                        data: childrenData,
                        isNews: this.isNews,
                        backPathName: pathName,
                        thisToken: this.newsToken,
                    },
                });
            }
        },

        // 取消提交
        cancelSubmission() {
            this.$toast('已取消！');
        },

        // 确认提交
        confirmSubmission() {
            const data = {
                BusinessInstanceId: this.approvalData.BusinessInstanceId,
                CurrentBusinessProcessId: this.CurrentBusinessProcess.CurrentBusinessProcessId,
                TransferMode: 10,
            };
            this.submitAPI(data, '提交成功！', '/interfaceApi/basicplatform/simpleflow/processes');
        },

        // 自由提交
        customSubmit() {
            this.$router.isBack = 2;
            const childrenData = {
                title: '自由提交',
                type: 'linkBtn',
                processData: this.processData,
            };
            let pathName = this.backPathName;
            if (this.isMessageHandling) {
                pathName = 'approvalProcess';
            }
            this.$router.push({
                name: 'submission',
                params: {
                    data: childrenData,
                    isNews: this.isNews,
                    backPathName: pathName,
                    thisToken: this.newsToken,
                },
            });
        },

        // 退回
        async sendBack() {
            if (this.isFillOpinion) {
                if (!this.isOpinion) {
                    this.$toast('请先填写意见！');
                    return;
                }
            }

            const data = {
                BusinessInstanceId: this.approvalData.BusinessInstanceId,
                CurrentBusinessProcessId: this.CurrentBusinessProcess.CurrentBusinessProcessId,
                TransferMode: 21,
            };

            if (!this.isNewestOpinion) {
                this.$dialog.confirm({
                    message: '填写的意见是上次办理时填写的，确认直接退回？',
                })
                    .then(() => {
                        this.submitAPI(data, '事项已退回!', '/interfaceApi/basicplatform/simpleflow/processes');
                    });
            } else {
                this.$dialog.confirm({
                    message: '确认退回？',
                })
                    .then(() => {
                        this.submitAPI(data, '事项已退回!', '/interfaceApi/basicplatform/simpleflow/processes');
                    })
                    .catch(() => {
                        this.$toast('取消退回！');
                    });
            }
        },
        // 流程结束
        async end() {
            if (this.isFillOpinion) {
                if (!this.isOpinion) {
                    this.$toast('请先填写意见！');
                    return;
                }
            }

            const data = {
                BusinessInstanceId: this.approvalData.BusinessInstanceId,
                CurrentBusinessProcessId: this.processData.CurrentBusinessProcess.CurrentBusinessProcessId,
                TransferMode: 40,
            };

            if (!this.isNewestOpinion) {
                this.$dialog.confirm({
                    message: '填写的意见是上次办理时填写的，确认直接结束？',
                })
                    .then(() => {
                        if (this.approvalData.BusinessInstanceId) {
                            this.submitAPI(data, '事项已办结!', '/interfaceApi/basicplatform/simpleflow/processes');
                        }
                    });
            } else if (this.approvalData.BusinessInstanceId) {
                this.$dialog.confirm({
                    message: '确认结束流程？',
                })
                    .then(() => {
                        this.submitAPI(data, '事项已办结!', '/interfaceApi/basicplatform/simpleflow/processes');
                    })
                    .catch(() => {
                        this.$toast('取消结束！');
                    });
            }
        },
        // 跨级审批
        async crossApproval() {
            if (this.isFillOpinion) {
                if (!this.isOpinion) {
                    this.$toast('请先填写意见！');
                    return;
                }
            }

            const data = {
                BusinessInstanceId: this.approvalData.BusinessInstanceId,
                CurrentBusinessProcessId: this.CurrentBusinessProcess.CurrentBusinessProcessId,
                TransferMode: 10,
            };

            if (!this.isNewestOpinion) {
                this.$dialog.confirm({
                    message: '填写的意见是上次办理时填写的，确认直接提交？',
                })
                    .then(() => {
                        if (this.CurrentBusinessProcess) {
                            this.submitAPI(data, '操作成功!', '/interfaceApi/basicplatform/simpleflow/crosshierarchy/approval');
                        } else {
                            this.$message({
                                message: '请先保存表单!',
                                type: 'warning',
                            });
                        }
                    });
            } else if (this.CurrentBusinessProcess) {
                this.$dialog.confirm({
                    title: '提交',
                    message: '确认提交?',
                })
                    .then(() => {
                        this.submitAPI(data, '操作成功!', '/interfaceApi/basicplatform/simpleflow/crosshierarchy/approval');
                    })
                    .catch(() => {
                        this.$toast('已取消操作!');
                    });
            } else {
                this.$message({
                    message: '请先保存表单!',
                    type: 'warning',
                });
            }
        },
        // 跨级退回
        async crossBackProcess() {
            if (this.isFillOpinion) {
                if (!this.isOpinion) {
                    this.$toast('请先填写意见！');
                    return;
                }
            }

            const data = {
                BusinessInstanceId: this.approvalData.BusinessInstanceId,
                CurrentBusinessProcessId: this.CurrentBusinessProcess.CurrentBusinessProcessId,
                TransferMode: 21,
            };

            if (!this.isNewestOpinion) {
                this.$dialog.confirm({
                    message: '填写的意见是上次办理时填写的，确认直接退回？',
                })
                    .then(() => {
                        if (this.CurrentBusinessProcess) {
                            this.submitAPI(data, '操作成功!', '/interfaceApi/basicplatform/simpleflow/crosshierarchy/approval');
                        } else {
                            this.$message({
                                message: '请先保存表单!',
                                type: 'warning',
                            });
                        }
                    });
            } else if (this.CurrentBusinessProcess) {
                this.$dialog.confirm({
                    title: '退回',
                    message: '确认退回?',
                })
                    .then(() => {
                        this.submitAPI(data, '操作成功!', '/interfaceApi/basicplatform/simpleflow/crosshierarchy/approval');
                    })
                    .catch(() => {
                        this.$toast('已取消操作!');
                    });
            } else {
                this.$message({
                    message: '请先保存表单!',
                    type: 'warning',
                });
            }
        },

        // 审核不通过
        async nopass() {
            if (this.isFillOpinion) {
                if (!this.isOpinion) {
                    this.$toast('请先填写意见！');
                    return;
                }
            }

            const data = {
                BusinessInstanceId: this.approvalData.BusinessInstanceId,
                CurrentBusinessProcessId: this.CurrentBusinessProcess.CurrentBusinessProcessId,
                TransferMode: 40,
                approval_status: 3,
            };

            if (!this.isNewestOpinion) {
                this.$dialog.confirm({
                    message: '填写的意见是上次办理时填写的，确认直接审核？',
                })
                    .then(() => {
                        this.submitAPI(data, '审核不通过!', '/interfaceApi/basicplatform/simpleflow/processes');
                    });
            } else {
                this.$dialog.confirm({
                    message: '确认审核不通过？',
                })
                    .then(() => {
                        this.submitAPI(data, '审核不通过!', '/interfaceApi/basicplatform/simpleflow/processes');
                    })
                    .catch(() => {
                        this.$toast('取消审核！');
                    });
            }
        },

        // 退回提交
        async returnSubmit() {
            const res = await this.phaseReturnStatusRequest(this.approvalData.BusinessInstanceId, this.CurrentBusinessProcess.BusinessPhaseId);
            // 是退回提交，提交到数据返回的退回环节，不是退回提交，走提交方法
            if (res) {
                const data = {
                    BusinessInstanceId: this.this.approvalData.BusinessInstanceId,
                    CurrentBusinessProcessId: this.CurrentBusinessProcess.CurrentBusinessProcessId,
                    TransferMode: 10,
                    NextPhsaeId: res.BusinessPhaseId,
                    NextApproverIds: res.ApproverId,
                    NextApproverNames: res.ApproverName,
                };
                let newText = '';
                if (res.ApproverName) {
                    newText = `提交到【${res.BusinessPhaseName}】环节的【${res.ApproverName}】进行办理？`;
                } else {
                    newText = `提交到【${res.BusinessPhaseName}】环节进行办理？`;
                }
                this.$dialog.confirm({
                    title: '确认提交',
                    message: newText,
                })
                    .then(() => {
                        this.submitAPI(data, '提交成功!');
                    })
                    .catch(() => {
                        this.$toast('已取消操作!');
                    });
            } else {
                this.submit();
            }
        },

        // 流程提交请求
        async submitAPI(data, message, url) {
            this.isloading = true;
            await this.submitAPIRequest(url, data);
            this.$toast.success(message);
            this.isReadOnly = true;
            this.isloading = false;
            if (this.isNews !== true) {
                this.$router.isBack = 1;
                this.$router.replace({
                    name: this.backPathName,
                    params: {
                        isRefresh: true,
                    },
                });
                this.$router.go(-1);
            }
            this.isloading = false;
        },
        // 意见
        opinion() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'approvalComments',
                params: {
                    currentBusinessProcess: this.CurrentBusinessProcess,
                    approvalData: this.approvalData,
                    isReadOnly: this.isReadOnly,
                    isNews: this.isNews,
                    thisToken: this.newsToken,
                    opinionRecord: this.opinionRecord,
                },
            });
        },
        // 拉取审批意见
        async getApprovalComments() {
            this.isloading = true;
            const res = await this.getApprovalCommentsRequest();
            // res == null, 没有意见表，不用验证意见是否已填
            if (!res) {
                this.isOpinion = true;
                this.isFillOpinion = false;
                this.isNewestOpinion = true;
            }
            if ((res?.opinion || '') !== '') {
                this.opinionRecord = res;
                this.isOpinion = true;
                if (res.business_process_id !== this.approvalData.BusinessProcessId) {
                    this.isNewestOpinion = false;
                } else {
                    this.isNewestOpinion = true;
                }
            }
            this.isloading = false;
        },
        // 沟通
        async communicate() {
            if (this.contractNo === '') { return; }
            const res = await this.communicateRequest();
            if (!res.netease_group_id) {
                this.gitUserAccid(res);
            } else {
                const callMobileData = {
                    conversationId: res.netease_group_id,
                    name: res.group_name,
                    type: '1',
                };
                this.$callMobile('JYTeamsNative', 'GetConversationInfo', callMobileData);
            }
        },
        // 获取联系人云信id
        async gitUserAccid(data) {
            const res = await this.gitUserAccidRequest(data);
            if (res.length > 0) {
                const callMobileData = {
                    uids: res,
                    groupName: data.group_name,
                    type: '0',
                    contractId: this.contractNo,
                };
                this.$callMobile('JYTeamsNative', 'jyCreatedGroupWithContractInfo', callMobileData);
            } else {
                this.$toast('当前审批流程暂时无法进行沟通！');
            }
            this.isloading = false;
        },
        // 原生调js回传群组json
        callback_GetTeamsListInfo(chartGroupJson) {
            const groupData = JSON.parse(chartGroupJson).teams[0];
            if (groupData.teamid && groupData.teamid !== 'undefined') {
                const res = this.addContractNetease(groupData.teamid);
                if (res) {
                    this.groupChat(groupData);
                }
            }
        },

        // 点群组列表进入群组聊天
        groupChat(data) {
            const callMobileData = {
                conversationId: data.teamid,
                name: data.teamName,
                type: '1',
            };
            this.$callMobile('JYTeamsNative', 'GetConversationInfo', callMobileData);
        },

        // 工程地址打开地图
        configurationMethod(data) {
            if (data) {
                const parameter = data.match(/\(([^)]*)\)/)[1].split(',');
                const mapData = {
                    engineering_location: this.essentialInfoData[parameter[0]],
                    x_coordinate_point: this.essentialInfoData[parameter[1]],
                    y_coordinate_point: this.essentialInfoData[parameter[2]],
                };
                this.$router.isBack = 2;
                this.$router.push({
                    path: 'ProjectLocation',
                    query: {
                        data: mapData,
                        parentData: this.approvalData,
                        type: 'approvalProcess',
                    },
                });
            }
        },
        // 查看表单
        openForm(data) {
            this.$router.isBack = 2;
            if (data.AppFormUrl === '') {
                this.$router.push({
                    name: 'formPreview',
                    params: {
                        formData: data,
                        approvalData: this.approvalData,
                        isNews: this.isNews,
                        thisToken: this.newsToken,
                    },
                });
            } else {
                let type = '';
                if (this.isMessageHandling) {
                    type = 'process_message';
                } else {
                    type = 'process';
                }
                this.$router.push({
                    name: data.AppFormUrl,
                    params: {
                        type: type,
                        listData: data,
                        approvalData: this.approvalData,
                        businessInstanceInfo: this.BusinessInstanceInfo,
                        isReadOnly: this.isReadOnly,
                        thisToken: this.newsToken,
                    },
                });
            }
        },
        // 附件预览
        attachmentPreview(data) {
            if (data.FileType !== '1') {
                this.$router.isBack = 2;
                const fileFormat = data.FileName.substring(data.FileName.length - 4, data.FileName.length);
                if (
                    fileFormat.indexOf('jpg') > -1
                    || fileFormat.indexOf('png') > -1
                    || fileFormat.indexOf('gif') > -1
                    || fileFormat.indexOf('jpeg') > -1
                ) {
                    this.getFileDetailFun(data.AFI_Code, 'preview_url');
                    setTimeout(() => {
                        ImagePreview({
                            images: [this.url],
                            closeable: true,
                        });
                    }, 300);
                } else {
                    this.getFileDetailFun(data.AFI_Code, 'preview_url');
                    setTimeout(() => {
                        this.$router.push({
                            name: 'attachmentPreview',
                            params: {
                                url: this.url,
                                isNews: this.isNews,
                            },
                        });
                    }, 300);
                }
            } else {
                this.thisFileID = data.FileID;
                this.attachmentData = this.allAttachmentData.filter(item => item.ParentID === data.FileID);
            }
        },
        // 获取文件下载预览地址
        getFileDetailFun(id, key) {
            this.$axios
                .get(this.GLOBAL.FILE_BASE_URL_OSS + 'api/GetFileInfo/' + id)
                .then(res => {
                    this.url = res[key];
                })
                .catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
        },

        // 附件返回上一级
        attachmentReturn() {
            const new_ParentID = this.allAttachmentData.filter(item => item.FileID === this.thisFileID)[0].ParentID;
            this.attachmentData = this.allAttachmentData.filter(item => item.ParentID === new_ParentID);
            this.thisFileID = this.attachmentData[0].ParentID;
        },

        // 单条提示已读
        async promptReadClick() {
            const res = await this.promptReadRequest(this.showUnreadData.RemindId);
            if (res) {
                this.showUnreadData.RecordStatus = 1;
                this.showTipsPopover = false;
            }
        },

        // 显示所有提示
        openAllTips() {
            this.showAllTips = true;
        },

        // 所有提示已读
        async allpromptReadClick() {
            const row = this.businessRemindList.filter(item => item.RecordStatus === 0);
            if (row.length > 0) {
                const res = await this.allPromptReadRequest(this.approvalData.BusinessInstanceId);
                if (res) {
                    this.showAllTips = false;
                    this.businessRemindList.forEach(item => {item.RemindId = 1;});
                }
            } else {
                this.showAllTips = false;
            }
        },

        // 多租户消息打开办理页面，取token
        getTenantToken(TenantId) {
            return this.$axios.$get(`/interfaceApi/auth/SwitchTenant/${TenantId}`, { token: this.newsToken });
        },

        // 获取基本信息字段数据请求
        getEssentialInfoFieldRequest() {
            return this.$axios.$get(`/interfaceApi/basicplatform/mobile/get_fields/${this.approvalData.BusinessCode}`, { token: this.newsToken });
        },

        // 获取基本信息数据请求
        getEssentialInfoDataRequest() {
            const url = `/interfaceApi/basicplatform/mobile/get_form_data/${this.approvalData.BusinessCode}/${this.approvalData.BusinessInstanceId}`;
            return this.$axios.$get(url, { token: this.newsToken });
        },

        // 根据环节获取流程实例信息请求
        getProcessDataRequest() {
            // eslint-disable-next-line max-len
            const url = `/interfaceApi/basicplatform/simpleflow/processes/${this.approvalData.BusinessInstanceId}/${this.approvalData.BusinessProcessId}`;
            return this.$axios.$get(url, { token: this.newsToken });
        },

        // 流程提交请求
        submitAPIRequest(url, data) {
            return this.$axios.$post(url, data, { token: this.newsToken });
        },

        // 拉取审批意见请求
        getApprovalCommentsRequest() {
            // eslint-disable-next-line max-len
            const url = `/interfaceApi/basicplatform/mobile/get_opinion_byuserid/${this.approvalData.BusinessCode}/${this.approvalData.BusinessInstanceId}/${this.$takeTokenParameters('Uid')}`;
            return this.$axios.$post(url, {}, { token: this.newsToken });
        },

        // 沟通请求
        communicateRequest() {
            return this.$axios.$get(`/interfaceApi/sale/contract_manager/get_contract_user_phone/${this.contractNo}`, { token: this.newsToken });
        },

        // 获取联系人云信id请求
        gitUserAccidRequest(data) {
            return this.$axios.$post('/interfaceApi/message/MessageNetease/get_accids', data.phones, { token: this.newsToken });
        },

        // 合同关联云信群组
        addContractNetease(teamid) {
            // eslint-disable-next-line max-len
            return this.$axios.put(`/interfaceApi/sale/contract_manager/add_contract_netease/${this.contractNo}/${teamid}`, {}, { token: this.newsToken });
        },

        // 环节退回状态请求
        phaseReturnStatusRequest(businessInstanceId, businessPhaseId) {
            const path = `/interfaceApi/basicplatform/simpleflow/processes/getlastreturnprocess/${businessInstanceId}/${businessPhaseId}`;
            return this.$axios.$get(path, { token: this.newsToken });
        },

        // 当前显示提示已读
        promptReadRequest(remindid) {
            const path = `/interfaceApi/basicplatform/simpleflow/businessinstance/click_businessremind/${remindid}`;
            return this.$axios.$put(path, {}, { token: this.newsToken });
        },

        // 全部提示已读请求
        allPromptReadRequest(businessInstanceId) {
            const path = `/interfaceApi/basicplatform/simpleflow/businessinstance/batch_click_businessremind/${businessInstanceId}`;
            return this.$axios.$put(path, {}, { token: this.newsToken });
        },

        // 获取环节数据请求
        getLinkDataRequest(businessInstanceId, businessPhaseId) {
            const path = `/interfaceApi/basicplatform/simpleflow/processes/getcurrentbusinessprocess/${businessInstanceId}/${businessPhaseId}`;
            return this.$axios.$get(path, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
.approvalProcess
    height 100%
    &.isNews
        section
            height calc(100% - 60rpx)
    .van-nav-bar
        z-index 9
        position relative
        .van-nav-bar__right
            &:active
                opacity 1
    .tips
        width 30rpx
        height 40rpx
        position relative
        .tipsBtn
            font-size 22rpx
            color #fff
        .van-badge
            top 10rpx
            right 0
        .tipsPopover
            color #F48400
            display flex
            align-items flex-start
            position absolute
            right 0
            top 45rpx
            width 280rpx
            padding 10rpx 30rpx 10rpx 10rpx
            border-radius 4rpx
            background #FFF5D1
            border 1px solid #FFDFAD
            box-shadow -4px 4px 8px rgba(0, 0, 0, 0.3)
            i
                font-size 20rpx
                color #F48400
                margin-right 5rpx
            span
                border-color: transparent transparent #FFDFAD transparent;
                border-style: solid;
                border-width: 0px 8px 8px 8px;
                width: 0;
                height: 0;
                position absolute
                right 12rpx
                top -8rpx
            button
                width 30rpx
                height 30rpx
                border none
                background none
                position absolute
                right 1px
                top 1px
            p
                font-size 14rpx
                line-height 20rpx
                text-align left
    section
        height calc(100% - 105rpx)
        overflow hidden
        position relative
        background #F0F0F0
        &.readOnly
            height calc(100% - 45rpx)
            .van-tabs
                .van-tabs__content
                    border-bottom none
        .van-tabs
            height 100%
            .van-tab
                .van-tab__text
                    font-size 14rpx
                &.van-tab--active
                    .van-tab__text
                        color #0078FB
                        font-size 16rpx
            .van-tabs__line
                background-color #0078FB
            .van-tabs__content
                background-color #fff
                height calc(100% - 44px)
                .van-tab__pane-wrapper
                    height 100%
                    overflow-x hidden
                    overflow-y scroll
                    -webkit-overflow-scrolling touch
                .noData
                    font-size 40rpx
                    line-height 200rpx
                    font-weight 600
                    color #ccc
                    text-align center
                .van-cell, .van-cell__left-icon
                    font-size 16rpx
                .essentialInfo
                    .van-tab__pane
                        .van-cell
                            .van-cell__value
                                -webkit-box-flex 2
                                -webkit-flex 2
                                flex 2
                .approvalForm
                    .formList
                        height 60rpx
                        align-items center
                        &:nth-child(even)
                            background #FAFAFA
                .formList
                    &:before
                        color #21BC9A
                        font-size 20rpx
                        margin-right 15rpx

                .appendix_list
                    .attachmentReturnBtn
                        width 120rpx
                        height: 30rpx
                        border 1px solid #91D5FF
                        background: #E6F7FF
                        font-size 12rpx
                        color #1890FF
                        border-radius: 0px 10rpx 0px 0px;
                    ul
                        border-top 1px solid #F0F0F0
                        li
                            display flex
                            align-items center
                            width 100%
                            padding 12rpx
                            border-bottom 1px solid #ebedf0
                            >i
                                line-height: 50rpx
                                width 30rpx
                                text-align: right
                                display: none
                            &.folder
                                i
                                    display: block
                            &.file
                                .fileInfo
                                    width calc(100% - 50rpx)
                    .fileName
                        width 100%
                        white-space nowrap
                        text-overflow ellipsis
                        overflow hidden
                    .fileIcon
                        font-size 16rpx
                        width 50rpx
                        text-align center
                        height 50rpx
                        line-height 50rpx
                        &:first-child
                            font-size 26rpx
                        &:last-child
                            font-size 14rpx
                            color #979EA7
                        &.icontupian::before
                            color rgba(133, 115, 226, 1)
                        &.iconpdf1::before
                            color rgba(255, 85, 98, 1)
                        &.iconbg-word::before
                            color rgba(84, 141, 254, 1)
                        &.iconxls::before
                            color rgba(72, 203, 129, 1)
                        &.iconPPT::before
                            color rgba(255, 147, 51, 1)
                        &.icontxt::before
                            color #f60
                    .fileInfo
                        width calc(100% - 50rpx)
                        p
                            font-size 16rpx
                            color #000
                            line-height 24rpx
                            &:last-child
                                display flex
                                justify-content space-between
                                em
                                    font-size 14rpx
                                    color #979EA7
                .flowChartList
                    width 100%
                    height 100%
                    overflow hidden
                    overflow-y auto
                    padding 14rpx
                    .procedureList
                        position relative
                        padding-bottom 25rpx
                        &:last-child
                            &:before
                                display: none
                        &:before
                            content ''
                            width 1px
                            height 100%
                            background: url(./images/up.png) repeat-y
                            position absolute
                            top 12rpx
                            left 20rpx
                        &.countersignatureNode
                            &:after
                                content ''
                                width 1px
                                height calc(100% - 105rpx)
                                background: url(./images/up.png) repeat-y
                                position absolute
                                top 17rpx
                                left 50rpx
                            .countersignatureTitle
                                display: flex
                                position: relative
                                z-index 9
                                color #FA6400
                                font-size: 16rpx
                                line-height: 32rpx
                                padding-left: 6rpx
                                margin-bottom: 20rpx
                                &:before
                                    content ''
                                    width 10rpx
                                    height 1px
                                    background: url(./images/across.png) repeat-x
                                    position absolute
                                    top 16rpx
                                    left 41rpx
                                .countersign
                                    width 32rpx
                                    height 32rpx
                                    background: url(./images/icon2.png) no-repeat
                                    text-align: center
                                    line-height: 32rpx
                                    margin-right: 20rpx
                            .listBox
                                padding-left: 70rpx
                                position: relative
                                h4
                                    color #FA6400
                                    position: relative
                                    &:before
                                        content ''
                                        width 35rpx
                                        height 1px
                                        background: url(./images/across.png) repeat-x
                                        position absolute
                                        top 10rpx
                                        left -32rpx
                        .listBox
                            h4
                                height 24rpx
                                font-size 14rpx
                                line-height 24rpx
                                padding-left 25rpx
                                margin-bottom: 10rpx
                                margin-left: 12rpx
                                display: flex
                                position: relative
                                z-index 9
                                &:after
                                    content ''
                                    width 7rpx
                                    height 7rpx
                                    border-radius 50%
                                    background #0078FB
                                    position absolute
                                    top 50%
                                    left 5rpx
                                    transform translateY(-50%)
                                span
                                    color #0078FB
                                    font-weight: 600
                            .userInfo
                                overflow hidden
                                display flex
                                span
                                    display: inline-block
                                    font-size 16rpx
                                    line-height 20rpx
                                    &.headPortrait
                                        width 40rpx
                                        height 40rpx
                                        position relative
                                        img
                                            width 40rpx
                                            height 40rpx
                                        i
                                            position absolute
                                            bottom 0
                                            right 0
                                            width 15rpx
                                            height 15rpx
                                            background url('./images/pass.png') no-repeat
                                            background-size 15rpx 15rpx
                                    &.name
                                        color #333333
                                        margin-left 15rpx
                                    &.state
                                        color #2BC671
                                    &.time
                                        margin-left 15rpx
                                        color #979EA7
                                        font-size: 13rpx
                                div
                                    width 100%
                                .stateBox
                                    display flex
                                    justify-content space-between
                            ul
                                margin-left: 55rpx
                                li
                                    padding: 14rpx 0
                                    border-bottom: 1px solid #D7D7D7
                                    font-size: 14rpx
                                    line-height: 20rpx
                                    color #4A4A4A
                                    margin-bottom: 10rpx
                                    &:last-child
                                        border-bottom none
        .iconfujian
            color #3495FB
        .communicate, .opinion, .tipsBtn
            position absolute
            right 0
            bottom 200rpx
            width 64rpx
            height 32rpx
            background rgba(255, 255, 255, 0.6)
            font-size 10rpx
            color #18AE39
            border-radius 16rpx 0 0 16rpx
            box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.2);
            border: 1px solid #B7D3BD;
            display flex
            justify-content center
            align-items center
            p
                font-size 14rpx
                margin-right 5rpx
        .opinion
            bottom 150rpx
            border: 1px solid #A9BCD2;
            color #0078FB
        .flowPathTips
            width 88%
            text-align: center
            border-radius 4rpx
            h4
                height: 40rpx;
                background: #F0F7FF;
                font-size 16rpx
                line-height 40rpx
                color #333333
                text-align center
            ul
                margin-top 14rpx
                li
                    border-bottom 1px solid #F0F0F0
                    padding-bottom: 14rpx
                    padding-top 14rpx
                    &:first-child
                        padding-top 0
                    >div
                        display flex
                        justify-content space-between
                        .state
                            width 8rpx
                            height: 8rpx
                            margin 6rpx 0 6rpx 20rpx
                            background: #F64A2C
                            border-radius 50%
                            &.read
                                background: #D7D7D7
                                &:before
                                    border-left-color #B6B7B8
                        p
                            font-size: 14rpx
                            color #666666
                            line-height: 20rpx
                            width: calc(100% - 50rpx)
                            padding-right: 14rpx
                            text-align: left
                    >p
                        font-size: 12rpx
                        color #999999
                        text-align: right
                        padding-right: 14rpx
                        margin-top: 14rpx
            .van-button
                margin: 14rpx 0
                width: 200px;
                height: 40px;
                background: rgba(0,120,251,0.06);
                border-radius: 2px;
                border: 1px solid rgba(0,120,251,0.3);
        .submitPopUp
            border-radius 4rpx
            .van-dialog__header
                padding 0
                height 40rpx
                line-height 40rpx
                background #F0F7FF
                font-size 16rpx
                color #333333
            .van-dialog__content
                .submitPopUpContent
                    .info
                        .infoList
                            display flex
                            align-items center
                            padding 30rpx
                            .icon
                                width: 44rpx;
                                height: 44rpx;
                                background: linear-gradient(131deg, #FBA763 0%, #FF7D48 100%);
                                border-radius: 4rpx;
                                margin-right 20rpx
                                font-size 22rpx
                                text-align center
                                line-height 44rpx
                                color #fff
                            h4
                                p
                                    font-size 14rpx
                                    color #666666
                                    margin-bottom 5rpx
                                span
                                    font-size 18rpx
                                    color #0078FB
                            &.approvalPhase
                                border-bottom 1px solid #F0F0F0
                                .icon
                                    background: linear-gradient(131deg, #53B0FF 0%, #2978FF 100%);
                            &.approver
                                h4
                                    span
                                        color #FF7F4A
                .tips
                    width 100%
                    padding 14rpx 20rpx 0
                    background #F8F8F8
                    font-size 14rpx
                    color #888888
            .van-dialog__footer
                background #F8F8F8
                .van-button
                    width 96rpx
                    height 32rpx
                    background: rgba(0,120,251,0.06);
                    border-radius: 2px;
                    border: 1px solid rgba(0,120,251,0.3);
                    font-size 14rpx
                    color #0078FB
                    margin 15rpx 20rpx
                    &:last-child
                        background #0078FB
                        color #fff
                        border none
</style>
